const analyzeRoutes = [
  {
    path: '',
    component: () => import('@/app/shared/layouts/main/Main.vue'),
    children: [
      // =============================================================================
      // PAGES
      // =============================================================================
      {
        path: '/analyze/dashboard',
        name: 'analyzeDashboard',
        component: () => import('./views/Dashboard.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'analyze' },
            { title: 'dashboard', active: true },
          ],
          pageTitle: 'Dashboard',
          rule: 'editor'
        }
      },
      {
        path: '/analyze/alerts',
        name: 'analyzeAlerts',
        component: () => import('./views/Alerts.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'analyze' },
            { title: 'alerts', active: true },
          ],
          pageTitle: 'Alerts',
          rule: 'editor'
        }
      },
      {
        path: '/analyze/calendar',
        name: 'analyzeCalendar',
        component: () => import('./views/Calendar.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'analyze' },
            { title: 'calendar', active: true },
          ],
          pageTitle: 'Calendar',
          rule: 'editor'
        }
      },
      {
        path: '/analyze/explore',
        name: 'analyzeExplore',
        component: () => import('./views/Analyze.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'analyze' },
            { title: 'explore', active: true },
          ],
          pageTitle: 'Insights',
          rule: 'editor'
        }
      }
    ]
  }
];

export default analyzeRoutes;
